import { OrderProduct } from '../../../../entities/order-product/OrderProduct'
import DashboardActionTypes from './DashboardActionTypes'

export interface OpenConfirmDialog {
  type: DashboardActionTypes.OPEN_CONFIRM_DIALOG
  payload: {
    declinedProduct: OrderProduct
    onEnd?: () => void
  }
}

export function openConfirmDialog(declinedProduct: OrderProduct, onEnd?: () => void): OpenConfirmDialog {
  return {
    type: DashboardActionTypes.OPEN_CONFIRM_DIALOG,
    payload: {
      declinedProduct,
      onEnd,
    },
  }
}

export interface CloseConfirmDialog {
  type: DashboardActionTypes.CLOSE_CONFIRM_DIALOG
}

export function closeConfirmDialog(): CloseConfirmDialog {
  return {
    type: DashboardActionTypes.CLOSE_CONFIRM_DIALOG,
  }
}

export interface ConfirmAcceptDeclinedProduct {
  type: DashboardActionTypes.CONFIRM_ACCEPT_DECLINED_PRODUCT
  payload: {
    product: OrderProduct
    onEnd?: () => void
  }
}

export function confirmAcceptDeclinedProduct(product: OrderProduct, onEnd?: () => void): ConfirmAcceptDeclinedProduct {
  return {
    type: DashboardActionTypes.CONFIRM_ACCEPT_DECLINED_PRODUCT,
    payload: {
      product,
      onEnd,
    },
  }
}
